function setAccordionOpen(item, isOpen) {
  const trigger = item.querySelector("[data-accordion-trigger]");
  const panel = item.querySelector("[data-accordion-panel]");
  if (!trigger || !panel) return;

  trigger.setAttribute("aria-expanded", isOpen ? "true" : "false");
  panel.hidden = !isOpen;
}

function preserveTriggerPosition(trigger, update) {
  const root = document.documentElement;
  const previousAnchor = root.style.overflowAnchor;
  root.style.overflowAnchor = "none";

  const top = trigger.getBoundingClientRect().top;
  update();

  const delta = trigger.getBoundingClientRect().top - top;
  if (delta) {
    window.scrollBy(0, delta);
  }

  requestAnimationFrame(() => {
    root.style.overflowAnchor = previousAnchor;
  });
}

function initAccordion(root) {
  const items = Array.from(root.querySelectorAll("[data-accordion-item]"));
  if (!items.length) return;

  items.forEach((item) => {
    const trigger = item.querySelector("[data-accordion-trigger]");
    if (!trigger) return;

    trigger.addEventListener("click", () => {
      const isOpen = trigger.getAttribute("aria-expanded") === "true";

      preserveTriggerPosition(trigger, () => {
        items.forEach((other) => {
          setAccordionOpen(other, false);
        });

        if (!isOpen) {
          setAccordionOpen(item, true);
        }
      });
    });
  });
}

export function initAccordions() {
  document.querySelectorAll("[data-accordion]").forEach(initAccordion);
}
